import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class AuthService {

    login(data) {
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/auth/login`, data , {
            headers: {
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    loginFrn(data) {
        return axios.post(`${api_url}/auth/login-frn`, data , {
        });
    }

    loginForConf(data) {
        return axios.post(`${api_url}/auth/login-configure`, data);
    }

    logout() {
        storage.logout();
    }

    checkUser() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/auth/check`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    checkConfig() {
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/auth/check-config`, {
            headers: {
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    configure(data) {
        return axios.get(`${api_url}/auth/configure/${data?.idMagasin}`, {
            headers: {
                Authorization: `Bearer ${data?.token}`
            }
        });
    }

    getMyClaims(target) {
        let mgToken = storage.getMgToken();
        let token = storage.getToken();
        return axios.get(`${api_url}/auth/claim-for/${target}`, {
            headers: {
                [mg_token_name]: `${mgToken}`,
                Authorization: `Bearer ${token}`,
            }
        });
    }

    viewProfile() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/auth/profile`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    updateProfile(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/auth/profile`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

}

export default new AuthService()